export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-database-823600be8d04212bb322f341715ce206.svg";